import { ThreeSixty, TrendingUpSharp } from "@mui/icons-material";
import { OpClass, AttrClass } from "./OpClass";

export class FxOpData {

  constructor(opList, attrList, opMenuList) {
    this.opMap = new Map();
    this.cmptList = null;
    this.opList = null;
    this.menuList = null;

    console.log("getFxmsConfig : OpData", opList, attrList, opMenuList);

    for (let op of opList) {
      op.uiWidth = parseInt(op.uiWdth);
      op.uiHeight = parseInt(op.uiHght);
      this.opMap.set(op.opId, op);

      op.isSelect = function () {
        return op.opTypeCd.toLowerCase() === "select";
      };
      op.isInsert = function () {
        return op.opTypeCd.toLowerCase() === "insert";
      };
      op.isUpdate = function () {
        return op.opTypeCd.toLowerCase() === "update";
      };
      op.isDelete = function () {
        return op.opTypeCd.toLowerCase() === "delete";
      };
      op.isUi = function () {
        return op.opTypeCd.toLowerCase() === "ui";
      };
      op.isComponent = function () {
        return op.opTypeCd.toLowerCase() === "component";
      };
      op.isDashboard = function () {
        return op.uiCmptName.toLowerCase() === "dashboard";
      };
    }

    // 기본 정렬
    opList.sort(function (a, b) {
      if (a.sortSeq > b.sortSeq) {
        return 1;
      }
      if (a.sortSeq < b.sortSeq) {
        return -1;
      }
      return 0;
    });

    // 속성 정렬
    attrList.sort(function (a, b) {
      if (a.sortSeq > b.sortSeq) {
        return 1;
      }
      if (a.sortSeq < b.sortSeq) {
        return -1;
      }
      return 0;
    });

    // 운용코드의 속성 만들기
    for (let attr of attrList) {
      // attr.uiWidth = attr.uiWidth > 10 ? attr.uiWidth : 100;

      AttrClass.initAttr(attr, this.opMap);

      for (let op of opList) {
        if (attr.opId === op.opId && attr.useYn === "Y") {
          if (op.attrList) {
            op.attrList.push(attr);
          } else {
            op.attrList = [attr];
          }

          // key값 설정
          if (attr.keyIndex > 0) {
            if (op.keyIndexList) {
              op.keyIndexList.push(attr);
            } else {
              op.keyIndexList = [attr];
            }
          }
        }
      }
    }

    for (let op of opList) {
      // 화면 크기 설정
      //if (op.uiCmptName && op.uiCmptName.startsWith("CRUD") && op.attrList) {
        op.maxWidth = this.getMaxWidth(op);
      //}

      // 그리드에서 ID 조회
      if (op.keyIndexList) {
        op.keyIndexList.sort(function (a, b) {
          if (a.keyIndex > b.keyIndex) {
            return 1;
          }
          return -1;
        });
      }
    }

    for (let op of opList) {
      // CRUD인 경우 속성이 없으면 CRUD-LIST의 크기를 갖는다.
      if (op.uiCmptName === "CRUD" && op.maxWidth === undefined) {
        for (let op2 of opList) {
          if (
            op2.upperOpId === op.opId &&
            op2.opTypeCd === "UI" &&
            op2.uiCmptName === "CRUD-LIST"
          ) {
            op.maxWidth = op2.maxWidth;
            op.maxWidthNum = op2.maxWidthNum;
            break;
          }
        }
      }

      op.getAttrValue = function (attrName, defVal) {
        if (op.attrList) {
          for (let attr of op.attrList) {
            if (attr.attrName === attrName) {
              if (typeof defVal === "number") {
                return parseInt(attr.attrDftVal);
              } else if (typeof defVal === "boolean") {
                return attr.attrDftVal === "Y" || attr.attrDftVal === "y";
              } else {
                return attr.attrDftVal;
              }
            }
          }
        }
        return defVal;
      };

      op.getAttrList = function (attrTypeCd) {
        const ret = [];
        if (op.attrList) {
          for (let attr of op.attrList) {
            if (attr.attrTypeCd === attrTypeCd) {
              ret.push(attr);
            }
          }
        }
        return ret;
      };

      op.getAttrSort = function () {
        if (op.attrList) {
          for (let attr of op.attrList) {
            if (attr.attrGrp === "sort") {
              return attr;
            }
          }
        }
        return undefined;
      };

      op.getCloseButton = function () {
        if (op.attrList) {
          for (let attr of op.attrList) {
            if (attr.isCloseButton()) {
              return attr;
            }
          }
        }
        return undefined;
      };
    }

    //
    // menu 찾기
    let menuList = [];

    if (opMenuList) {
      // 속성 정렬
      opMenuList.sort(function (a, b) {
        if (a.sortSeq > b.sortSeq) {
          return 1;
        }
        if (a.sortSeq < b.sortSeq) {
          return -1;
        }
        return 0;
      });
      for (let menu of opMenuList) {
        if (menu.upperOpId === "*") {
          const menuOp = this.opMap.get(menu.opId);
          if (menuOp) {
            menuOp.subMenuList = [];
            menuOp.opTitle = menu.menuName; // 메뉴에 설정된 이름으로 변경한다.
            menuOp.menuFullName = menuOp.opTitle;
            menuList.push(menuOp);
          }
        } else {
          for (let upper of menuList) {
            if (menu.upperOpId === upper.opId) {
              const menuOp = this.opMap.get(menu.opId);
              if (menuOp) {
                menuOp.subMenuList = [];
                menuOp.opTitle = menu.menuName; // 메뉴에 설정된 이름으로 변경한다.
                menuOp.menuFullName = upper.opTitle + "/" + menuOp.opTitle;
                upper.subMenuList.push(menuOp);
              }
              break;
            }
          }
        }
      }
    } else {
      const menuMap = new Map();
      for (let op of opList) {
        if (op.opTypeCd === "MENU") {
          op.menuFullName = op.opTitle;
          menuMap.set(op.opId, op);
        }
      }
      for (let [opId, menu] of menuMap) {
        let upperMenu = menuMap.get(menu.upperOpId);

        // 상위 메뉴가 있으면 메뉴 그룹의 하나의 아이템으로 들어간다.
        if (upperMenu) {

          menu.menuFullName = upperMenu.opTitle + "/" + menu.opTitle;

          if (upperMenu.subMenuList) {
            upperMenu.subMenuList.push(menu);
          } else {
            upperMenu.subMenuList = [menu];
            menuList.push(upperMenu);
          }
        }

        // 상위메뉴가 없으면 자신이 메뉴가 된다.
        else {
          menu.subMenuList = [];
          menuList.push(menu);
        }
      }
    }

    // 콤포넌트 찾기
    let cmptList = [];
    for (let op of opList) {
      if (op.opTypeCd === "COMPONENT") {
        cmptList.push(op);
      }
    }

    this.cmptList = cmptList;
    this.opList = opList;
    this.menuList = menuList;

    console.log(
      "getFxmsConfig : OpData",
      this.opMap,
      this.opList,
      this.cmptList,
      this.menuList
    );
  }

  getComponentList() {
    return this.cmptList;
  }

  getOpList() {
    return this.opList;
  }

  getMenuList() {
    return this.menuList;
  }

  getActionMenuList() {
    const ret = [];
    for (const menu of this.menuList) {
      for (const a of menu.subMenuList) {
        ret.push(a);
      }
    }
    return ret;
  }

  getOpObj(opId) {
    return this.opMap.get(opId);
  }

  getMaxWidth(opObj) {
    let maxWidth;

    if ( opObj.uiWidth > 0 ) {
      maxWidth = opObj.uiWidth;
    } else if ( opObj.attrList ) {
      if (opObj.uiCmptName === "CRUD-LIST") {
        maxWidth = 400;

        for (let attr of opObj.attrList) {
          if (attr.attrGrp === "grid") {
            maxWidth += attr.uiWidth;
          }
        }
      } else {
        let lineNum;
        let map = new Map();
        maxWidth = 0;

        for (let attr of opObj.attrList) {
          lineNum = parseInt(attr.sortSeq / 10);
          let width = map.get(lineNum);
          width = width == null ? attr.uiWidth : width + attr.uiWidth;
          width += 300; // label
          map.set(lineNum, width);

          if (width > maxWidth) {
            maxWidth = width;
          }
        }

        maxWidth += 260; // 좌우 마진
      }
    }

    opObj.maxWidthNum = maxWidth;

    return maxWidth < 600
      ? "xs" //
      : maxWidth < 960
        ? "sm" //
        : maxWidth < 1280
          ? "md" //
          : maxWidth < 1920
            ? "lg"
            : "xl";

    // xs (extra-small) : 0px ~ 600px
    // sm (small) : 600px ~ 960px
    // md (medium): 960px ~ 1280px
    // lg (large) : 1280px ~ 1920px
    // xl (extra-large) : 1920px ~
  }

}